import { render, staticRenderFns } from "./RequestPasswordChange.vue?vue&type=template&id=5464029e&scoped=true&"
import script from "./RequestPasswordChange.vue?vue&type=script&lang=js&"
export * from "./RequestPasswordChange.vue?vue&type=script&lang=js&"
import style0 from "./RequestPasswordChange.vue?vue&type=style&index=0&id=5464029e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5464029e",
  null
  
)

export default component.exports